module.exports = __webpack_public_path__ + "static/img/icon-sofa-dark.0ec5f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-sofa-dark.png
// module id = 1026
// module chunks = 34